import "./App.css";
import { useEffect } from "react";
import Layout from "./Layout.js";
import trackVisit from "./trackVisit";
import DevPingButton from "./DevPingButton";

function App() {
  useEffect(() => {
    // Sets up lightweight listeners immediately; the actual ping is sent on exit
    // (and only for engaged, human-looking visitors).
    trackVisit();
  }, []);

  return (
    <>
      <Layout />
      <DevPingButton />
    </>
  );
}

export default App;
